/**
 * get a unique id
 */
let _uniqueId = 1;
export function uniqueId() {
    return _uniqueId++;
}
//# sourceMappingURL=unique-id.js.map